import axios from "axios";
import {
  GET_COMPONENT_LIST_BY_COMPANY_ID,
  GET_MASTER_COMPONENT_LIST,
  DELETE_COMPONENT_BY_ID,
  SET_STAKEHOLDER_COMPONENT,
} from "../constants/index";
import { ApiCall } from "../../utils/index"

// Integrating API to get all component list
export const getAllComponentList = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/component`, token);

    dispatch({
      type: GET_COMPONENT_LIST_BY_COMPANY_ID,
      payload: result.data,
    });
  } catch (error) {
    request.onError(error?.message);
  }
};

// Integrating API to Add new component
export const addNewComponent = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.post("/component", request.body, token);

    request.onSuccess();
  } catch (error) {
    request.onError(error?.message);
  }
};

// Integrate API to update existing component
export const updateComponent = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(`/component/${request.componentId}`, request.body, token)

    request.onSuccess();
  } catch (error) {
    request.onError(error?.message);
  }
};

// Integrate API to delete component
export const deleteComponentById = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(`/component/${request.componentId}`, token);
    request.onSuccess()
  } catch (error) {
    request.onError(error?.message);
  }
};

// Integrate API to get deault component list from master
export const getMasterComponentList =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/master/component/company`, token);
      dispatch({
        type: GET_MASTER_COMPONENT_LIST,
        payload: result.data,
      });
      request.onSuccess();
    } catch (error) {
      request.onError(
        "Unable to fetch component list. Please try again later."
      );
    }
  };

// Integrate API to download default component list from master.
export const downloadMasterComponent =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/component/import/master_components",  request.payload, token);
      request.onSuccess()
    } catch (error) {
      request.onError();
    }
  };

  export const getStakeholderComponents =
    (request) => async (dispatch, getState) => {
      try {
        const {
          auth: { token },
        } = getState();
        const result = await ApiCall.get(`/component/stakeholder`, token);
        dispatch({
          type: SET_STAKEHOLDER_COMPONENT,
          payload: result.data,
        });
        request.onSuccess();
      } catch (error) {
        request.onError(
          "Unable to get stakeholder component list"
        );
      }
    };
